import text from './text.json'
import {Link} from 'react-router-dom'
import {routes} from '../../routes'
import {NoAppointmentsIcon} from '../../icons'
import classNames from 'classnames'

const TrialPeriodContent = ({isDarkMode}) => {
    return (
        <div className={classNames('empty-content-body', {
            dark: isDarkMode
        })}>
            <NoAppointmentsIcon/>
            <p dangerouslySetInnerHTML={{__html: text.trial_period_text}}/>
            <div className="content-button">
                <Link className="simple-blue-button" to={routes.plans.path}>{text.plans}</Link>
            </div>
        </div>
    )
}

export default TrialPeriodContent
